import { useEffect } from 'react';
import { useUserSettingsContext } from 'contexts';
import { selectRoom } from 'state/selectors';
import { isFeatureOn } from 'useCase/featureFlags/featureFlagsApi';
import { FEATURES } from 'consts';
import { mutedSpeechDetectionStore } from '../state/store/store';
import { createMutedSpeechDetector, type DetectorOptions } from '../mutedSpeechDetector';
import { setActiveDetector, releaseActiveDetector } from '../guardController';

const options: DetectorOptions = {
    threshold: 0.03,
    speechDurationMs: 200,
    cooldownMs: 3000,
    silenceGapMs: 250,
    hideDelayMs: 2000,
};

/**
 * Детектирует ситуации, когда пользователь пытается говорить с выключенным микрофоном
 * во время звонка.
 */
export function useMutedSpeechDetection() {
    const { audioEnabled, audioInputDeviceId, permissions } = useUserSettingsContext();

    const isMutedSpeechDetectionEnabled = isFeatureOn(FEATURES.VCS_MUTED_SPEECH_DETECTION_ENABLED);

    const room = selectRoom();

    useEffect(() => {
        const isPrevent = !isMutedSpeechDetectionEnabled || !room || audioEnabled || !permissions.audio;
        if (isPrevent) return;

        const detector = createMutedSpeechDetector(options, {
            onMutedSpeechChange: (flag) => mutedSpeechDetectionStore.setIsUserSpeakWhileMuted(flag),
        });
        setActiveDetector(detector);
        detector.start(audioInputDeviceId);

        return () => {
            detector.stop();
            releaseActiveDetector(detector);
        };
    }, [isMutedSpeechDetectionEnabled, room, audioEnabled, audioInputDeviceId, permissions.audio]);
}
